/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Cluster2xConnectionToken, ClusterInfo, ClusterInfo2x, ClusterInfo3x, ProductEdition } from '../types/cluster';
import { assertNever } from './assert';

export const isCluster2x = (cluster: ClusterInfo): cluster is ClusterInfo2x => {
  const { edition } = cluster;
  switch (edition) {
    case null:
    case ProductEdition.AI:
    case ProductEdition.GGCE:
    case ProductEdition.GGEE:
    case ProductEdition.GGUE:
      return true;
    case ProductEdition.AI3:
    case ProductEdition.GG9:
    case ProductEdition.GG9CE:
    case ProductEdition.GG9EE:
    case ProductEdition.GG9UE:
      return false;
    default:
      return assertNever(edition);
  }
};

export const onlyIfClusterIs2x = (cluster: ClusterInfo) => (isCluster2x(cluster) ? cluster : null);

export const isCluster3x = (cluster: ClusterInfo): cluster is ClusterInfo3x => !isCluster2x(cluster);

export const serializeCluster2xConnectionToken = (payload: string): Cluster2xConnectionToken =>
  globalThis.btoa(payload);
export const deserializeCluster2xConnectionToken = (token: Cluster2xConnectionToken): string => globalThis.atob(token);
